<template>
  <div class="cascader-options-multi">
    <el-popover popper-class="cascader-multi-popper" v-model="visible" trigger="click" placement="bottom-start" :disabled="disabled">
      <div style="">
        <el-cascader-panel ref="cascader" :options="manyShowList" :props="props" v-model="checkValue" @change="tagMain($refs.cascader.getCheckedNodes())" />
      </div>
      <div slot="reference">
        <el-input class="zwx-input" :class="checkValue.length ? 'zwx-input-close' : null" v-model="inputValue" readonly :placeholder="placeholder" :disabled="disabled" :style="`width:${width}px !important`">
          <i slot="suffix" class="el-input__icon el-icon-circle-close" @click="
              checkValue = []
              manyList = []
              visible = false
            " />
          <i slot="suffix" class="el-input__icon el-icon-arrow-down" :class="visible ? ' input-up' : ''" />
        </el-input>
        <div v-if="$zwxBase.verifyIsNotBlank(manyList)" class="tags" :style="`width:${width - 2}px !important`">
          <template v-if="showFullTag === true && collapsetags == false">
            <div v-for="val in manyList" :key="val.value" class="tags-items">
              {{ val.fullLabel }}
              <i class="el-icon-error" @click="tagClick(val)" />
            </div>
          </template>
          <template v-if="showFullTag === true && collapsetags == true && $zwxBase.verifyIsNotBlank(manyList)">
            <div class="tags-items">
              {{ manyList[0].fullLabel }}
              <i class="el-icon-error" @click="tagClick(manyList[0])" />
            </div>
            <div class="tags-items" style="color: #909399">+ {{ manyList.length }}</div>
          </template>
          <template v-if="showFullTag === false && collapsetags == false">
            <div v-for="val in manyList" :key="val.value" class="tags-items">
              {{ val.label }}
              <i class="el-icon-error" @click="tagClick(val)" />
            </div>
          </template>
          <template v-if="showFullTag === false && collapsetags == true && $zwxBase.verifyIsNotBlank(manyList)">
            <div class="tags-items">
              {{ manyList[0].label }}
              <i class="el-icon-error" @click="tagClick(manyList[0])" />
            </div>
            <div class="tags-items" style="color: #909399">+ {{ manyList.length }}</div>
          </template>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'CascaderOptionsMulti',
  model: {
    prop: 'value',
    event: 'propEvent',
  },
  components: {},
  props: {
    value: { type: String, default: '' },
    width: { type: String, default: '400' },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    returnParent: { type: Boolean, default: false },
    dataNameFiled: { type: String, required: true },
    dataCodeFiled: { type: String, required: true },
    dataUpCodeFiled: { type: String, required: true },
    codeLevelNo: { type: String, required: true },
    showFullTag: { type: Boolean, required: false },
    collapsetags: { type: Boolean, required: false },
    expandTrigger: { type: String, default: 'click' },
    placeholder: { type: String, default: '请选择' },
    props: {
      type: Object,
      default() {
        return {
          value: this.dataCodeFiled,
          label: this.dataNameFiled,
          children: this.dataUpCodeFiled,
          multiple: this.multiple,
          expandTrigger: this.expandTrigger,
        }
      },
    },
    options: {
      type: Array,
      default() {
        return []
      },
    },
    parent: { type: Boolean, default: true },
  },
  data() {
    return {
      api: this.$store.state.api,
      visible: false,
      manyShowList: this.options,
      manyList: [],
      inputValue: this.value,
      isIndeterminate: false,
      checkValue: [],
    }
  },
  created() { },
  mounted() { },
  watch: {
    inputValue(val) {
      this.$emit('propEvent', val)
    },
    manyList() {
      this.inputValue = this.manyList.map(e => e.value).join(',')
    },
    options(u) {
      this.manyShowList = u
    },
    value: {
      handler() {
        if (this.value) {
          this.echoCheckDataList()
        } else {
          this.manyList = []
          this.checkValue = []
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {},
  methods: {
    //tags内容处理
    tagMain(val) {
      this.manyList = []
      if (this.showFullTag === true) {
        // 显示层级
        val.forEach(e => {
          if (e.children.length == 0) {
            let label = e.label
            if (this.$zwxBase.verifyIsNotBlank(e.parent)) {
              label = this.getParentLabel(e.parent, label)
            }
            e.fullLabel = label
            this.manyList.push(e)
          }
        })
      } else {
        if (this.returnParent) {
          this.manyList = val
        } else {
          this.manyList = val.filter(e => e.children.length == 0)
        }
      }
    },
    tagClick(val) {
      this.manyList = this.manyList.filter(e => e.value != val.value)
      this.checkValue = this.checkValue.filter(e => e.indexOf(val.value) == -1)
    },
    getParentLabel(e, label) {
      label = e.label + '/' + label
      if (this.$zwxBase.verifyIsNotBlank(e.parent)) {
        this.getParentLabel(e.parent, label)
      }
      return label
    },
    getLabel() {
      if (this.checkValue) {
        let inputValues = []
        this.getlabelFul(this.manyList, inputValues)
        this.inputValue = inputValues.join(',')
      }
    },
    getlabelFul(arr, inputValues) {
      arr.forEach(child => {
        inputValues.push(child.label)
        if (this.$zwxBase.verifyIsNotBlank(child[this.dataUpCodeFiled])) {
          this.getlabelFul(child[this.dataUpCodeFiled], inputValues)
        }
      })
    },
    // 回显
    echoCheckDataList() {
      this.checkValue = []
      let conArr = this.value.split(',')
      //cascader 的默认值
      conArr.forEach(e => {
        this.cascaderDefault(e, this.manyShowList)
      })
      this.$nextTick(() => {
        this.tagMain(this.$refs.cascader.getCheckedNodes())
      })
    },
    //cascader 的默认值
    cascaderDefault(code, data) {
      data.forEach(e => {
        if (this.$zwxBase.verifyIsNotBlank(e[this.dataCodeFiled]) && e[this.dataCodeFiled].indexOf(code) != -1) {
          if (e[this.dataUpCodeFiled]) {
            this.cascaderDefault(code, e[this.dataUpCodeFiled])
          } else {
            this.checkValue.push(e[this.codeLevelNo].split('.'))
          }
        } else if (e[this.dataUpCodeFiled]) {
          this.cascaderDefault(code, e[this.dataUpCodeFiled])
        }
      })
    },
    clear() {
      this.manyList = []
      this.checkValue = []
      this.inputValue = ''
    },
  },
}
</script>

<style lang="less" scoped>
.cascader-options-multi {
  font-size: 14px !important;

  .el-icon-arrow-down:before {
    content: '\e6df' !important;
  }

  .el-icon-circle-close {
    display: none;
  }

  .el-icon-arrow-down {
    font-size: 14px !important;
  }

  /deep/ .zwx-input-close:hover {
    .el-icon-circle-close {
      display: inline-block;
    }

    .el-icon-arrow-down {
      display: none;
    }
  }

  .input-up {
    transform: rotateZ(-180deg);
    margin-left: -10px;
    margin-top: -1px;
  }

  /deep/ .el-popover__reference {
    position: relative;
    .tags {
      position: absolute;
      top: 3px;
      left: 1px;
      right: 20px;
      bottom: 1px;
      background: #fff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      overflow: hidden;

      .tags-items {
        padding: 0 8px;
        background: #f2f2f2;
        color: #1f2d3d;
        margin-left: 6px;
        white-space: nowrap;

        .el-icon-error {
          color: #c0c4cc;
          cursor: pointer;
        }
      }
    }
  }

  /deep/ .input .el-input__inner {
    padding-right: 20px !important;
  }
}
</style>

<style lang="less">
.cascader-multi-popper {
  padding: 0;
  margin-top: unset !important;

  .popper__arrow {
    display: none !important;
  }

  .el-cascader-panel.is-bordered {
    border: none;
  }

  .el-cascader-menu {
    color: #3a485e;
  }

  .el-cascader-node__label {
    font-size: 14px;
    padding: 0 12px !important;
  }

  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: #316cf5 !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #316cf5;
    border-color: #316cf5;
  }

  .el-checkbox__inner:hover {
    border-color: #316cf5;
  }
}
</style>
